<div class="content-card-wide mdl-card ">

  <div class="mdl-card__title mdl-button mdl-js-button" (click)="expandClick($event)" [ngClass]="{'selected-header': (isExpanded && !parent), 'parent-header-color': parent}">
    <h6 class="expand-panel-heading" [ngClass]="{titlebold: parent}">{{ panelTitle }} </h6>
    <div class="mdl-layout-spacer"></div>
    <label class="mdl-button mdl-js-button mdl-button--icon">
      <i class="material-icons">{{isExpanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</i>
    </label>

  </div>
  <div class="mdl-card__supporting-text black-font" *ngIf="isExpanded">
    <ng-content></ng-content>
  </div>
</div>